/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Compare_Maturity_ExcelInputs */

const en_gc_resources_compare_maturity_excel = /** @type {(inputs: Gc_Resources_Compare_Maturity_ExcelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Established product and ecosystem`)
};

const zh_gc_resources_compare_maturity_excel = /** @type {(inputs: Gc_Resources_Compare_Maturity_ExcelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成熟的产品与生态`)
};

/**
* | output |
* | --- |
* | "Established product and ecosystem" |
*
* @param {Gc_Resources_Compare_Maturity_ExcelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_compare_maturity_excel = /** @type {((inputs?: Gc_Resources_Compare_Maturity_ExcelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Compare_Maturity_ExcelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_compare_maturity_excel(inputs)
	return zh_gc_resources_compare_maturity_excel(inputs)
});
export { gc_resources_compare_maturity_excel as "gc.resources.compare.maturity.excel" }